/* eslint-disable */
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Timestamp } from "firebase/firestore";
import {
  collection,
  getDocs,
  orderBy,
  query,
  where,
} from "firebase/firestore";
import { db } from "../../../../firebase";
import { Popover } from "antd";
import { useTranslation } from "react-i18next";
import workerAPI from "../../../../api/worker/worker_service";

const MostDemandedProducts = ({ products }) => {
  const { t, i18n } = useTranslation();
  const account = useSelector((state) => state.AccountReducer);
  const worker = useSelector((state) => state.workerReducer);
  const store = useSelector((state) => state.StoreReducer);

  const currencyMap = {
    دج: {
      ar: "دج",
      fr: "DA",
      en: "DZD",
    },
  };
  const localizedCurrency =
    currencyMap[store.currencySymbol]?.[i18n.language] || store.currencySymbol;
  // Mode produit
  const isClassicMode = (account?.productMode ?? "classic") === "classic";

  // Timestamps pour filtres
  const current_timestamp = Timestamp.fromDate(new Date());

  const todayy = new Date();
  todayy.setHours(0, 0, 0, 0);
  const todayTimestamp = Timestamp.fromDate(todayy);

  const oneWeekAgo = new Date();
  oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
  const oneWeekAgoTimestamp = Timestamp.fromDate(oneWeekAgo);

  const oneMonthAgo = new Date();
  oneMonthAgo.setDate(oneMonthAgo.getDate() - 30);
  const oneMonthAgoTimestamp = Timestamp.fromDate(oneMonthAgo);

  // States
  const [data, setData] = useState([]);
  const [filterFirebase, setFilterFirebase] = useState(oneWeekAgoTimestamp);
  const [filterFirebaseStart, setFilterFirebaseStart] =
    useState(current_timestamp);

  const [showCustomDate, setShowCustomDate] = useState(false);
  const [showCustomDateMobile, setShowCustomDateMobile] = useState(false);
  const [selectedFilterDate, setSelectedFilterDate] = useState("week");
  const [endDate, setEndDate] = useState("");

  useEffect(() => {
    if (!account) return;

    const fetchOrders = async () => {
      try {
        const fetchedOrders = await workerAPI.getOrders(
          filterFirebase,
          filterFirebaseStart
        );

        const filteredOrders = fetchedOrders
          .filter((order) => order.deleted !== 1)
          .sort((a, b) => {
            const timeA = a.timeStamp?._seconds || a.timeStamp?.seconds || 0;
            const timeB = b.timeStamp?._seconds || b.timeStamp?.seconds || 0;
            return timeB - timeA;
          })
          .map((item, index, array) => ({
            ...item,
            index: array.length - index + 999,
          }));

        setData(filteredOrders);
      } catch (error) {
        console.error("Erreur lors de la récupération des commandes :", error);
      }
    };

    fetchOrders();
  }, [account, filterFirebaseStart, filterFirebase]);

  // Filtrer produits selon le mode
  const filteredProducts = products.filter((product) =>
    isClassicMode
      ? product.type !== "digitalProducts"
      : product.type === "digitalProducts"
  );

  // Calcul des métriques produits
  const calculateProductMetrics = () => {
    // Filtrer aussi les commandes selon le mode
    const relevantOrders = data.filter((order) =>
      isClassicMode
        ? order.type !== "digitalProducts"
        : order.type === "digitalProducts"
    );

    return filteredProducts.map((product) => {
      const relatedOrders = [];

      relevantOrders.forEach((order) => {
        if (Array.isArray(order.products)) {
          order.products.forEach((orderProduct) => {
            if (orderProduct.image === product.image) {
              relatedOrders.push({
                deleveryStatus: order.deleveryStatus,
                status: order.status,
              });
            }
          });
        }
      });

      const totalOrders = relatedOrders.length;

      let confirmedOrders = 0;
      let returnedOrders = 0;

      if (isClassicMode) {
        confirmedOrders = relatedOrders.filter(
          (o) => o.deleveryStatus === "3"
        ).length;
        returnedOrders = relatedOrders.filter(
          (o) => o.deleveryStatus === "6"
        ).length;
      } else {
        confirmedOrders = relatedOrders.filter(
          (o) => o.status == 3 || o.status == 5
        ).length;
        returnedOrders = relatedOrders.filter((o) => o.status == 4).length;
      }

      const confirmationRate =
        totalOrders > 0
          ? ((confirmedOrders / totalOrders) * 100).toFixed(1)
          : "0.0";
      const returnRate =
        totalOrders > 0
          ? ((returnedOrders / totalOrders) * 100).toFixed(1)
          : "0.0";

      return {
        ...product,
        totalOrders,
        confirmationRate,
        returnRate,
      };
    });
  };

  const productMetrics = calculateProductMetrics();

  // Trier par commandes totales
  productMetrics.sort((a, b) => b.totalOrders - a.totalOrders);

  // Gestion filtre (jour/semaine/mois)
  const handleTabChange = (activeKey) => {
    setShowCustomDate(false);
    setShowCustomDateMobile(false);
    switch (activeKey) {
      case "1":
        setFilterFirebase(todayTimestamp);
        setSelectedFilterDate("day");
        break;
      case "2":
        setFilterFirebase(oneWeekAgoTimestamp);
        setSelectedFilterDate("week");
        break;
      case "3":
        setFilterFirebase(oneMonthAgoTimestamp);
        setSelectedFilterDate("month");
        break;
      default:
        break;
    }
  };

  // Troncature noms produits
  const truncateName = (name, maxLength = 20) =>
    name.length > maxLength ? name.substring(0, maxLength) + "..." : name;

  const hasProducts = productMetrics.length > 0;

  // Empty state component shared between both layouts
  const EmptyState = () => (
    <div className="flex flex-col items-center justify-center py-10 min-h-64 w-full h-full ">
      <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mb-3">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-8 w-8 text-gray-400"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
          />
        </svg>
      </div>
      <span className="text-gray-500 text-sm">
        {t("dashboard.MostDemandedProducts.noData")}
      </span>
      <span className="text-gray-400 text-xs mt-1">
        {t("dashboard.MostDemandedProducts.noData2")}
      </span>
    </div>
  );

  // Card layout for mobile
  const MobileLayout = ({ isClassicMode }) => (
    <div className="space-y-3 h-full flex-1 overflow-y-auto">
      {productMetrics.map((product, index) => (
        <div
          key={product.id || index}
          className="bg-gray-50 dark:!bg-[#181919] rounded-lg p-3 transition-all hover:shadow-sm"
        >
          <div className="flex items-start justify-between">
            <div className="flex">
              <div className="h-10 w-10 flex-shrink-0 bg-white rounded-md shadow-sm flex items-center justify-center p-2">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="mr-3">
                <p className="font-medium text-gray-800 dark:text-white m-0">
                  {truncateName(product.name)}
                </p>
                <div className="flex items-center text-xs text-gray-500 dark:text-gray-400">
                  <span className="ml-2">
                    {product.price} {localizedCurrency}
                  </span>
                  <span className="h-1 w-1 bg-gray-300 rounded-full mx-1"></span>
                  <span>
                    {product.totalOrders} {t("dashboard.bigChart.order")}
                  </span>
                </div>
              </div>
            </div>

            <div className="flex flex-col items-end">
              <div className="flex items-center mb-1.5">
                <span className="text-xs text-gray-600 ml-2">
                  {isClassicMode
                    ? t("dashboard.MostDemandedProducts.confirmation")
                    : t("ui.paymentLabel")}
                </span>
                <div className="bg-gray-200 h-1.5 w-16 rounded-full overflow-hidden">
                  <div
                    className="h-full bg-gradient-to-r from-green-400 to-green-500"
                    style={{
                      width: `${Math.min(product.confirmationRate, 100)}%`,
                    }}
                  ></div>
                </div>
                <span className="text-xs text-green-600 mr-1.5 font-medium">
                  {product.confirmationRate}%
                </span>
              </div>

              <div className="flex items-center">
                <span className="text-xs text-gray-600 ml-2 dark:text-gray-400">
                  {" "}
                  {t("dashboard.MostDemandedProducts.retour")}
                </span>
                <div className="bg-gray-200 h-1.5 w-16 rounded-full overflow-hidden">
                  <div
                    className="h-full bg-gradient-to-r from-red-400 to-red-500"
                    style={{ width: `${Math.min(product.returnRate, 100)}%` }}
                  ></div>
                </div>
                <span className="text-xs text-red-600 mr-1.5 font-medium">
                  {product.returnRate}%
                </span>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );

  const TabletDesktopLayout = ({ isClassicMode }) => (
    <div className="overflow-y-auto flex-1 -mx-5">
      <div className="min-w-full">
        <table className="min-w-full divide-y divide-gray-100 dark:!divide-[#3c3a3d]">
          <thead className="sticky top-0 bg-white z-10 rounded-t-md">
            <tr className="bg-gray-100 dark:!bg-[#141414] dark:!text-white text-center">
              <th className="p-4 font-medium pr-2">
                {" "}
                {t("dashboard.MostDemandedProducts.product")}
              </th>
              <th className="p-4 font-medium">
                {t("dashboard.MostDemandedProducts.price")}
              </th>
              <th className="p-4 font-medium">
                {t("dashboard.MostDemandedProducts.orders")}
              </th>
              <th className="p-4 font-medium">
                {t("dashboard.MostDemandedProducts.tauxConfirmation")}
              </th>
              <th className="p-4 font-medium">
                {t("dashboard.MostDemandedProducts.tauxRetour")}
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100 dark:!divide-[#3c3a3d]">
            {productMetrics.map((product, index) => (
              <tr
                key={product.id || index}
                className="hover:bg-gray-50 dark:hover:bg-[#0f172a] transition-colors"
              >
                <td className="px-6 py-3">
                  <div className="flex items-center">
                    <div className="rounded-lg overflow-hidden shadow-sm border-2 border-white w-14 h-14 bg-[#faf1ff]">
                      <img
                        className="w-full h-full object-cover"
                        src={
                          product.image ? product.image : "/product-foorweb.png"
                        }
                        alt={product.name}
                      />
                    </div>
                    <div className="mr-3">
                      <span className="font-medium text-lg text-gray-700 dark:!text-white">
                        {truncateName(product.name, 25)}
                      </span>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-3">
                  <span className="font-medium text-lg text-gray-700 dark:!text-white">
                    {product.price} {localizedCurrency}
                  </span>
                </td>
                <td className="px-6 py-3">
                  <span className="font-medium text-lg text-gray-700 dark:!text-white">
                    {product.totalOrders}
                  </span>
                </td>
                <td className="px-6 py-3">
                  <div className="flex items-center">
                    <div className="w-12 bg-gray-100 rounded-full h-1.5 overflow-hidden">
                      <div
                        className="bg-green-400 h-1.5"
                        style={{
                          width: `${Math.min(product.confirmationRate, 100)}%`,
                        }}
                      ></div>
                    </div>
                    <span className="font-medium text-xs mr-2 text-gray-700 dark:!text-white">
                      {product.confirmationRate}%
                    </span>
                  </div>
                </td>
                <td className="px-6 py-3">
                  <div className="flex items-center">
                    <div className="w-12 bg-gray-100 rounded-full h-1.5 overflow-hidden">
                      <div
                        className="bg-red-400 h-1.5"
                        style={{
                          width: `${Math.min(product.returnRate, 100)}%`,
                        }}
                      ></div>
                    </div>
                    <span className="font-medium text-xs mr-2 text-gray-700 dark:!text-white">
                      {product.returnRate}%
                    </span>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );

  const handleCustomDateSubmit = () => {
    if (!endDate) return;

    const selectedDate = new Date(endDate);
    selectedDate.setHours(0, 0, 0, 0);
    const selectedTimestamp = Timestamp.fromDate(selectedDate);

    setFilterFirebase(selectedTimestamp);
    setSelectedFilterDate("custom");
    setShowCustomDate(false);
    setShowCustomDateMobile(false);
  };

  const formatDisplayDate = () => {
    if (selectedFilterDate === "custom" && endDate) {
      const date = new Date(endDate);
      return date.toLocaleDateString("ar-DZ", {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    }
    return t("costumDate");
  };

  const DesktopDatePickerContent = () => (
    <div className=" dark:!bg-[#181919] rounded-lg shadow-lg border border-gray-200 p-4 min-w-[280px]">
      <div className="mb-3">
        <label className="block text-sm font-medium text-gray-700 mb-2 dark:text-white ">
          {t("chooseCostumeDate")}
        </label>
        <input
          type="date"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 outline-none transition-colors"
        />
      </div>
      <div className="flex justify-end gap-2">
        <button
          type="button"
          onClick={() => setShowCustomDate(false)}
          className="px-4 py-2 text-sm text-gray-600 hover:text-gray-800 transition-colors dark:text-white"
        >
          {t("annule")}
        </button>
        <button
          type="button"
          onClick={handleCustomDateSubmit}
          disabled={!endDate}
          className="px-4 py-2 text-sm bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors dark:text-white"
        >
          {t("ok")}
        </button>
      </div>
    </div>
  );

  const MobileDatePickerModal = () => (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4 sm:hidden">
      <div className="bg-white dark:!bg-[#181919] rounded-lg shadow-xl max-w-sm w-full p-6">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold text-gray-800 dark:!text-white">
            {" "}
            {t("chooseCostumeDate")}
          </h3>
          <button
            onClick={() => setShowCustomDateMobile(false)}
            className="text-gray-500 hover:text-gray-700"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <div className="mb-6">
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 outline-none"
          />
        </div>

        <div className="flex gap-3">
          <button
            onClick={() => setShowCustomDateMobile(false)}
            className="flex-1 px-4 py-3 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
          >
            {t("annule")}
          </button>
          <button
            onClick={handleCustomDateSubmit}
            disabled={!endDate}
            className="flex-1 px-4 py-3 bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            {t("ok")}
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <div className="bg-white dark:!bg-[#181919] col-span-1 md:col-span-3 rounded-lg shadow-sm w-full h-[500px] dark:border dark:border-[#3c3a3d]">
      <div className="p-4 flex flex-col h-full">
        <div className="flex justify-between items-center mb-4 shrink-0">
          <h3 className="font-bold text-lg text-gray-800 dark:text-white">
            {t("dashboard.MostDemandedProducts.title")}
          </h3>
          <p className="text-sm bg-blue-50 dark:!bg-[#141414] text-green-600 dark:text-green-50 px-3 py-1 rounded-full m-0">
            {productMetrics.length}{" "}
            {t("dashboard.MostDemandedProducts.products")}
          </p>
        </div>

        <div className="mb-4">
          <div className="block sm:hidden">
            <div className="bg-white dark:!bg-[#141414] dark:!text-white rounded-lg shadow-sm border border-gray-200 dark:!border-[#3c3a3d] p-2">
              <div className="grid grid-cols-3 gap-1 mb-2">
                <button
                  className={`px-3 py-2 text-xs font-medium rounded-md transition-all duration-200 dark:!border-[#3c3a3d] ${
                    selectedFilterDate === "day"
                      ? "bg-[#9b59bf] text-white shadow-sm dark:!border-[#3c3a3d]"
                      : "text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-[#181919 dark:!border-[#3c3a3d]]"
                  }`}
                  onClick={() => handleTabChange("1")}
                >
                  {t("jour")}
                </button>
                <button
                  className={`px-3 py-2 text-xs font-medium rounded-md transition-all duration-200 dark:border-[#3c3a3d] ${
                    selectedFilterDate === "week"
                      ? "bg-[#9b59bf] text-white shadow-sm dark:!border-[#3c3a3d]"
                      : "text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-[#181919] dark:!border-[#3c3a3d]"
                  }`}
                  onClick={() => handleTabChange("2")}
                >
                  {t("7jours")}
                </button>
                <button
                  className={`px-3 py-2 text-xs font-medium rounded-md transition-all duration-200 dark:border-[#3c3a3d] ${
                    selectedFilterDate === "month"
                      ? "bg-[#9b59bf] text-white shadow-sm"
                      : "text-gray-600 hover:bg-gray-100 dark:hover:bg-[#181919] dark:text-gray-300"
                  }`}
                  onClick={() => handleTabChange("3")}
                >
                  {t("mounth")}
                </button>
              </div>

              <button
                onClick={() => setShowCustomDateMobile(true)}
                className={`w-full dark:border-[#3c3a3d] px-3 py-2 text-xs font-medium rounded-md transition-all duration-200 flex items-center justify-center gap-2 ${
                  selectedFilterDate === "custom"
                    ? "bg-[#9b59bf] text-white shadow-sm"
                    : "text-gray-600 hover:bg-gray-100 dark:hover:bg-[#181919] dark:text-gray-300"
                }`}
              >
                <svg
                  className="w-4 h-4"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 122.88 122.89"
                  fill="currentColor"
                >
                  <path d="M81.61,4.73C81.61,2.12,84.19,0,87.38,0s5.77,2.12,5.77,4.73V25.45c0,2.61-2.58,4.73-5.77,4.73s-5.77-2.12-5.77-4.73V4.73ZM66.11,105.66c-.8,0-.8-10.1,0-10.1H81.9c.8,0,.8,10.1,0,10.1ZM15.85,68.94c-.8,0-.8-10.1,0-10.1H31.64c.8,0,.8,10.1,0,10.1Zm25.13,0c-.8,0-.8-10.1,0-10.1H56.77c.8,0,.8,10.1,0,10.1Zm25.13,0c-.8,0-.8-10.1,0-10.1H81.9c.8,0,.8,10.1,0,10.1Zm25.14-10.1H107c.8,0,.8,10.1,0,10.1H91.25c-.8,0-.8-10.1,0-10.1ZM15.85,87.3c-.8,0-.8-10.1,0-10.1H31.64c.8,0,.8,10.1,0,10.1ZM41,87.3c-.8,0-.8-10.1,0-10.1H56.77c.8,0,.8,10.1,0,10.1Zm25.13,0c-.8,0-.8-10.1,0-10.1H81.9c.8,0,.8,10.1,0,10.1Zm25.14,0c-.8,0-.8-10.1,0-10.1H107c.8,0,.8,10.1,0,10.1Zm-75.4,18.36c-.8,0-.8-10.1,0-10.1H31.64c.8,0,.8,10.1,0,10.1Zm25.13,0c-.8,0-.8-10.1,0-10.1H56.77c.8,0,.8,10.1,0,10.1ZM29.61,4.73C29.61,2.12,32.19,0,35.38,0s5.77,2.12,5.77,4.73V25.45c0,2.61-2.58,4.73-5.77,4.73s-5.77-2.12-5.77-4.73V4.73ZM6.4,43.47H116.47v-22a3,3,0,0,0-.86-2.07,2.92,2.92,0,0,0-2.07-.86H103a3.2,3.2,0,0,1,0-6.4h10.55a9.36,9.36,0,0,1,9.33,9.33v92.09a9.36,9.36,0,0,1-9.33,9.33H9.33A9.36,9.36,0,0,1,0,113.55V21.47a9.36,9.36,0,0,1,9.33-9.33H20.6a3.2,3.2,0,1,1,0,6.4H9.33a3,3,0,0,0-2.07.86,2.92,2.92,0,0,0-.86,2.07v22Zm110.08,6.41H6.4v63.67a3,3,0,0,0,.86,2.07,2.92,2.92,0,0,0,2.07.86H113.55a3,3,0,0,0,2.07-.86,2.92,2.92,0,0,0,.86-2.07V49.88ZM50.43,18.54a3.2,3.2,0,0,1,0-6.4H71.92a3.2,3.2,0,1,1,0,6.4Z" />
                </svg>
                {formatDisplayDate()}
              </button>
            </div>
          </div>

          <div className="hidden sm:flex items-center justify-between">
            <div className="bg-white dark:!bg-[#141414] dark:text-white rounded-xl shadow-sm border border-gray-200 dark:!border-[#3c3a3d] overflow-hidden">
              <div className="flex items-center">
                <div className="flex">
                  <button
                    className={`dark:text-white px-4 py-2.5 text-sm font-medium transition-all duration-200 ${
                      selectedFilterDate === "day"
                        ? "bg-[#9b59bf] text-white shadow-sm"
                        : "text-gray-600 hover:bg-purple-300 hover:text-purple-600"
                    }`}
                    onClick={() => handleTabChange("1")}
                  >
                    {t("jour")}
                  </button>
                  <button
                    className={`dark:text-white px-4 py-2.5 text-sm font-medium transition-all duration-200 ${
                      selectedFilterDate === "week"
                        ? "bg-[#9b59bf] text-white shadow-sm"
                        : "text-gray-600 hover:bg-purple-300 hover:text-purple-600"
                    }`}
                    onClick={() => handleTabChange("2")}
                  >
                    {t("7jours")}
                  </button>
                  <button
                    className={`px-4 py-2.5 text-sm  dark:text-white font-medium transition-all duration-200 ${
                      selectedFilterDate === "month"
                        ? "bg-[#9b59bf] text-white shadow-sm"
                        : "text-gray-600 hover:bg-purple-300 hover:text-purple-600"
                    }`}
                    onClick={() => handleTabChange("3")}
                  >
                    {t("mounth")}
                  </button>
                </div>

                {/* <div className="w-px h-6 bg-gray-200 "></div> */}

                <Popover
                  content={<DesktopDatePickerContent />}
                  trigger="click"
                  placement="bottomRight"
                  open={showCustomDate}
                  onOpenChange={setShowCustomDate}
                >
                  <button
                    className={`px-3 py-2.5 text-sm font-medium dark:text-white transition-all duration-200 flex items-center gap-2 ${
                      selectedFilterDate === "custom"
                        ? "bg-[#9b59bf] text-white"
                        : "text-gray-600  hover:bg-purple-300 hover:text-purple-600"
                    }`}
                  >
                    <svg
                      className="w-4 h-4"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 122.88 122.89"
                      fill="currentColor"
                    >
                      <path d="M81.61,4.73C81.61,2.12,84.19,0,87.38,0s5.77,2.12,5.77,4.73V25.45c0,2.61-2.58,4.73-5.77,4.73s-5.77-2.12-5.77-4.73V4.73ZM66.11,105.66c-.8,0-.8-10.1,0-10.1H81.9c.8,0,.8,10.1,0,10.1ZM15.85,68.94c-.8,0-.8-10.1,0-10.1H31.64c.8,0,.8,10.1,0,10.1Zm25.13,0c-.8,0-.8-10.1,0-10.1H56.77c.8,0,.8,10.1,0,10.1Zm25.13,0c-.8,0-.8-10.1,0-10.1H81.9c.8,0,.8,10.1,0,10.1Zm25.14-10.1H107c.8,0,.8,10.1,0,10.1H91.25c-.8,0-.8-10.1,0-10.1ZM15.85,87.3c-.8,0-.8-10.1,0-10.1H31.64c.8,0,.8,10.1,0,10.1ZM41,87.3c-.8,0-.8-10.1,0-10.1H56.77c.8,0,.8,10.1,0,10.1Zm25.13,0c-.8,0-.8-10.1,0-10.1H81.9c.8,0,.8,10.1,0,10.1Zm25.14,0c-.8,0-.8-10.1,0-10.1H107c.8,0,.8,10.1,0,10.1Zm-75.4,18.36c-.8,0-.8-10.1,0-10.1H31.64c.8,0,.8,10.1,0,10.1Zm25.13,0c-.8,0-.8-10.1,0-10.1H56.77c.8,0,.8,10.1,0,10.1ZM29.61,4.73C29.61,2.12,32.19,0,35.38,0s5.77,2.12,5.77,4.73V25.45c0,2.61-2.58,4.73-5.77,4.73s-5.77-2.12-5.77-4.73V4.73ZM6.4,43.47H116.47v-22a3,3,0,0,0-.86-2.07,2.92,2.92,0,0,0-2.07-.86H103a3.2,3.2,0,0,1,0-6.4h10.55a9.36,9.36,0,0,1,9.33,9.33v92.09a9.36,9.36,0,0,1-9.33,9.33H9.33A9.36,9.36,0,0,1,0,113.55V21.47a9.36,9.36,0,0,1,9.33-9.33H20.6a3.2,3.2,0,1,1,0,6.4H9.33a3,3,0,0,0-2.07.86,2.92,2.92,0,0,0-.86,2.07v22Zm110.08,6.41H6.4v63.67a3,3,0,0,0,.86,2.07,2.92,2.92,0,0,0,2.07.86H113.55a3,3,0,0,0,2.07-.86,2.92,2.92,0,0,0,.86-2.07V49.88ZM50.43,18.54a3.2,3.2,0,0,1,0-6.4H71.92a3.2,3.2,0,1,1,0,6.4Z" />
                    </svg>
                    {formatDisplayDate()}
                  </button>
                </Popover>
              </div>
            </div>
          </div>
        </div>

        {showCustomDateMobile && <MobileDatePickerModal />}

        {hasProducts ? (
          <>
            {/* Mobile layout - only visible on small screens */}
            <div className="sm:hidden flex-1 overflow-y-auto overflow-x-hidden">
              <MobileLayout />
            </div>

            <div className="hidden sm:flex flex-1 overflow-y-auto overflow-x-hidden">
              <TabletDesktopLayout isClassicMode={isClassicMode} />
            </div>
          </>
        ) : (
          <div className="flex-1 overflow-y-auto overflow-x-hidden">
            <EmptyState />
          </div>
        )}
      </div>
    </div>
  );
};

export default MostDemandedProducts;
